/* ===== pm-search.js — the PM search panel (2026-09-22) =====================
   Derrick: "theres also no search feature so add smart search feature".

   Markup is server-rendered (snippets/pm-search-overlay.liquid); this file only
   opens/closes it, adds recent searches, and swaps in live results from
   sections/pm-predictive-search.liquid through Shopify's Section Rendering.

   FOUR RULES THAT ARE LOAD-BEARING (PLAN §4.2, Codex R1 #8):
   1. A live response is painted ONLY if it is HTTP 200, contains the section's
      [data-pm-psearch-root], and that root's data-q equals the query we asked
      for. Anything else is a failure, never a paint.
   2. Every keystroke aborts the in-flight request AND bumps a sequence number;
      a response whose sequence is not the latest is dropped even if it arrives
      (a browser can resolve an aborted fetch late).
   3. Any failure shows "press enter" and leaves the real GET form intact, so
      ordinary search is never lost. After a 429 no suggest request is sent for
      10 s — retrying sustains a throttle.
   4. Readiness (html[data-pm-search-ready]) is published LAST. pm-nav-guard
      holds a tap on the trigger until then and replays it through our handler.
   ========================================================================= */
(function () {
  'use strict';
  var root = document.querySelector('[data-pm-search]');
  if (!root) return;

  var SUGGEST = root.getAttribute('data-suggest-url') || '/search/suggest';
  var SECTION = 'pm-predictive-search';
  var PARAMS = '&section_id=' + SECTION +
    '&resources%5Btype%5D=product%2Ccollection%2Cquery' +
    '&resources%5Blimit%5D=10&resources%5Blimit_scope%5D=each' +
    /* `show`, not `last`: keeps Shopify's relevance order. With `last` a sold-out exact match
       (DOODLE BOB SHORTS) fell below nine loosely related products and out of the list. The
       section decides what counts as a match (see sections/pm-predictive-search.liquid). */
    '&resources%5Boptions%5D%5Bunavailable_products%5D=show' +
    '&resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Ctag';
  var DEBOUNCE = 160;
  var RECENT_KEY = 'pm:search:recent';
  var RECENT_MAX = 5;

  var form = root.querySelector('[data-pm-search-form]');
  var input = root.querySelector('[data-pm-search-input]');
  var idle = root.querySelector('[data-pm-search-idle]');
  var live = root.querySelector('[data-pm-search-results]');
  var status = root.querySelector('[data-pm-search-status]');
  var announce = root.querySelector('[data-pm-search-live]');
  var recentWrap = root.querySelector('[data-pm-search-recent]');
  var recentList = root.querySelector('[data-pm-search-recent-list]');
  var panel = root.querySelector('.pm-srch__panel');

  var ctl = null, seq = 0, timer = null, pausedUntil = 0, lastFocus = null, openState = false;

  /* ---- recent searches: a per-viewer convenience, so every access is guarded ---- */
  function readRecent() {
    try { var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function saveRecent(q) {
    try {
      var list = readRecent().filter(function (x) { return String(x).toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) {}
  }
  function paintRecent() {
    if (!recentWrap || !recentList) return;
    var list = readRecent();
    recentList.textContent = '';
    list.forEach(function (q) {
      var a = document.createElement('a');
      a.className = 'pm-srch__chip t-nav';
      a.setAttribute('data-pm-search-term', q);
      a.href = searchHref(q);
      a.textContent = q;            /* textContent: shopper input never becomes markup */
      recentList.appendChild(a);
    });
    recentWrap.hidden = list.length === 0;
  }
  function searchHref(q) {
    return (root.getAttribute('data-search-url') || '/search') + '?q=' + encodeURIComponent(q) +
      '&type=product&options%5Bprefix%5D=last';
  }

  /* ---- states ---- */
  function showIdle() {
    if (ctl) { ctl.abort(); ctl = null; }
    seq++;
    live.hidden = true; live.textContent = ''; live.removeAttribute('data-q');
    status.hidden = true;
    idle.hidden = false;
    announce.textContent = '';
  }
  function showFallback() {
    live.hidden = true;
    idle.hidden = true;
    status.hidden = false;
  }

  function suggest(q) {
    if (Date.now() < pausedUntil) { showFallback(); return; }
    if (ctl) ctl.abort();
    ctl = window.AbortController ? new AbortController() : null;
    var my = ++seq;
    root.setAttribute('aria-busy', 'true');
    fetch(SUGGEST + '?q=' + encodeURIComponent(q) + PARAMS, {
      signal: ctl ? ctl.signal : undefined,
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    }).then(function (r) {
      if (r.status === 429) { pausedUntil = Date.now() + 10000; throw new Error('HTTP 429'); }
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      if (my !== seq) return;                          /* rule 2: stale */
      var host = document.createElement('div');
      host.innerHTML = html;                           /* our own server-rendered section */
      var node = host.querySelector('[data-pm-psearch-root]');
      var got = node && (node.getAttribute('data-q') || '').trim().toLowerCase();
      if (!node || got !== q.trim().toLowerCase()) throw new Error('unexpected body');  /* rule 1 */
      live.innerHTML = node.innerHTML;
      live.setAttribute('data-q', q);                  /* which query is on screen (tests, debugging) */
      idle.hidden = true;
      status.hidden = true;
      live.hidden = false;
      var n = live.querySelectorAll('.pm-srch__row:not(.pm-srch__row--coll)').length;
      announce.textContent = n ? (n + (n === 1 ? ' product' : ' products')) : (live.textContent.trim().split('\n')[0] || '');
    }).catch(function (e) {
      if ((e && e.name === 'AbortError') || my !== seq) return;
      showFallback();                                  /* rule 3 */
    }).then(function () {
      if (my === seq) root.removeAttribute('aria-busy');
    });
  }

  function onInput() {
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q) { showIdle(); return; }
    timer = setTimeout(function () { suggest(q); }, DEBOUNCE);
  }

  /* ---- open / close ---- */
  function open(prefill) {
    if (openState) { input.focus(); return; }
    openState = true;
    lastFocus = document.activeElement;
    /* The cart drawer and this panel are mutually exclusive. */
    var drawer = document.querySelector('[data-pm-drawer]');
    if (drawer && drawer.getAttribute('data-open') === 'true' &&
        window.PMCart && typeof window.PMCart.close === 'function') {
      /* Only when it is actually open: PMCart.close() restores ITS last focus, which would
         otherwise pull focus off the search input we are about to focus. */
      try { window.PMCart.close(); } catch (e) {}
    }
    paintRecent();
    root.hidden = false;
    document.documentElement.classList.add('pm-srch-open');
    [].forEach.call(document.querySelectorAll('[data-pm-search-open]'), function (t) {
      t.setAttribute('aria-expanded', 'true');
    });
    if (typeof prefill === 'string') { input.value = prefill; onInput(); }
    /* `search-opened` is the THEME's own "search is open" flag. header-component's mouseleave
       handler calls document.activeElement.blur() unless it is set — and opening this panel
       moves the pointer off the header, so without it the input lost focus the instant it got
       it (measured: activeElement = <body>). It also keeps the header solid under the scrim. */
    document.body.classList.add('search-opened');
    /* Focus SYNCHRONOUSLY, inside the tap's own event: iOS Safari only raises the keyboard for a
       focus() made during a user gesture. The panel is already un-hidden, so it is focusable. */
    focusInput();
    /* Safety net for any later blur from the page (an app, a late header script). */
    setTimeout(function () {
      if (openState && !root.contains(document.activeElement)) focusInput();
    }, 180);
  }
  function focusInput() {
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
  }
  function close() {
    if (!openState) return;
    openState = false;
    clearTimeout(timer);
    if (ctl) { ctl.abort(); ctl = null; }
    seq++;
    root.hidden = true;
    document.documentElement.classList.remove('pm-srch-open');
    document.body.classList.remove('search-opened');
    /* The theme parks a queued menu-drawer open behind this event while search-opened is set. */
    try { document.dispatchEvent(new CustomEvent('theme:search:close', { bubbles: true })); } catch (e) {}
    [].forEach.call(document.querySelectorAll('[data-pm-search-open]'), function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---- triggers: every [data-pm-search-open] on the page, present or future ---- */
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest && ev.target.closest('[data-pm-search-open]');
    if (!t) return;
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button > 0) return;  /* new-tab stays native */
    ev.preventDefault();
    open();
  });

  root.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-pm-search-close]')) { ev.preventDefault(); close(); return; }
    var chip = ev.target.closest('[data-pm-search-term]');
    if (chip && !(ev.metaKey || ev.ctrlKey)) {
      /* A chip fills the box and shows live results in place — faster than a page load,
         and the shopper can still refine. Its href is the no-JS fallback. */
      ev.preventDefault();
      input.value = chip.getAttribute('data-pm-search-term') || chip.textContent.trim();
      input.focus();
      onInput();
    }
  });

  input.addEventListener('input', onInput);

  form.addEventListener('submit', function () {
    var q = input.value.trim();
    if (q) saveRecent(q);
    /* No preventDefault: the real GET to the search page IS the full-results path. */
  });

  /* ---- keyboard: Escape closes; arrows move focus between results; focus is trapped ---- */
  function options() {
    var scope = live.hidden ? idle : live;
    return [].slice.call(scope.querySelectorAll('[data-pm-srch-opt], [data-pm-search-term]'))
      .filter(function (el) { return el.offsetParent !== null; });
  }
  root.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') { ev.preventDefault(); close(); return; }
    if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
      var opts = options();
      if (!opts.length) return;
      var i = opts.indexOf(document.activeElement);
      ev.preventDefault();
      if (ev.key === 'ArrowDown') {
        (i < 0 ? opts[0] : opts[Math.min(i + 1, opts.length - 1)]).focus();
      } else if (i <= 0) {
        input.focus();
      } else {
        opts[i - 1].focus();
      }
      return;
    }
    if (ev.key !== 'Tab') return;
    var f = [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden])'))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  });

  /* BFCache: coming Back to a page with the panel open must not leave a stale overlay. */
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) close(); });

  window.PMSearch = { open: open, close: close };

  /* Rule 4: readiness LAST. */
  document.documentElement.setAttribute('data-pm-search-ready', '');
  document.dispatchEvent(new CustomEvent('pm:search:ready'));
})();
